import { InAppMessaging } from '@/components/messaging/InAppMessaging';

export default function Messaging() {
  return (
    <div className="container mx-auto py-8 px-4">
      <div className="mb-8">
        <h1 className="text-3xl font-bold">Messages</h1>
        <p className="text-muted-foreground mt-2">
          Send and receive messages with other users
        </p>
      </div>

      <InAppMessaging />
    </div>
  );
}
